import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { isItStaff } from '@/lib/itSupport';
import PageLoader from '@/components/base/PageLoader';

interface ItStaffGuardProps {
  /** フラグ非保有者をリダイレクトする先 */
  redirectTo: string;
}

/**
 * ITフラグ（is_it_admin / is_it_developer）ベースのアクセスガード。
 * RoleGuard がロール単位なのに対し、こちらは「ロール非依存のプロフィールフラグ」で判定する。
 * AuthGuard の内側（＝ログイン済み）で使用する。
 */
export default function ItStaffGuard({ redirectTo }: ItStaffGuardProps) {
  const { profile, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (!profile || !isItStaff(profile)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}